<template>
  <main class="about">
<div v-show="checkHideContents(FirstLayer)">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1 class="_kanji">会社情報</h1>
        </div>
      </div>

    <section class="tagJumpTarget" id="AboutOverview" v-scroll='handleScrollForBackground'>
      <div class="areaH2">
        <h2>会社概要</h2>
      </div>
        <div class="rowView overview">
					<dl v-for="(j, resetIndexKey) in originListProfile" :key="resetIndexKey" tabindex="0">
<dt>{{j.title}}</dt>
<dd v-html="replaceBr(dateData(j.content))"></dd>
					</dl>
<!--
					<dl>
<dt>社名</dt>
<dd>豊嶋精密工業株式会社</dd>
					</dl>
					<dl>
<dt>代表者</dt>
<dd>豊嶋 唯充</dd>
					</dl>
					<dl>
<dt>本社所在地</dt>
<dd>〒141-0031<br>
東京都品川区西五反田5-24-8</dd>
					</dl>
					<dl>
<dt>資本金</dt>
<dd>1000万円</dd>
					</dl>
					<dl>
<dt>設立</dt>
<dd>1959年6月22日</dd>
					</dl>
					<dl>
<dt>従業員数</dt>
<dd>10名（2023年3月時点）</dd>
					</dl>
					<dl>
<dt>取引銀行</dt>
<dd>城南信用金庫 東京シティ信用金庫 みずほ銀行(順不同)</dd>
					</dl>
					<dl>
<dt>営業品目</dt>
<dd>◆加工分類<br>
精密板金 タレパン加工 曲げ加工 スポット溶接加工 溶接加工 組立加工</dd>
					</dl>
					<dl>
<dt>製品紹介</dt>
<dd>通信機器部品 業務用光学機器部品 電源関連機器部品</dd>
					</dl>
-->
			</div>
    </section>

    <section class="tagJumpTarget" id="AboutHistory" v-scroll='handleScrollForBackground'>
      <div class="areaH2">
        <h2>沿革</h2>
      </div>
        <div class="rowView overview">
					<dl v-for="(j, resetIndexKey) in originListHistory" :key="resetIndexKey" tabindex="0">
<dt v-html="isoDateToDisplayDateMonth(j.date)"></dt>
<dd v-html="replaceBr(j.content)"></dd>
					</dl>
<!--
					<dl>
<dt>1959年6月</dt>
<dd>(有)福智製作所設立</dd>
					</dl>
					<dl>
<dt>1989年10月</dt>
<dd>(有)福智製作所から株式会社フクチに商号変更</dd>
					</dl>
					<dl>
<dt>2006年1月</dt>
<dd>城南島工場を取得 </dd>
					</dl>
					<dl>
<dt>2006年5月</dt>
<dd>本社工場<br>
3次元ソリッド板金CAD導入</dd>
					</dl>
					<dl>
<dt>2007年5月</dt>
<dd>城南島工場<br>
リアマニプレーター付きACサーボ・ダイレクトツインドライブ搭載<br>タレットパンチプレスEM258NT導入</dd>
					</dl>
					<dl>
<dt>2008年6月</dt>
<dd>本社工場<br>
曲げ加工データ作成全自動CAM Dr.ABE_Bend導入</dd>
					</dl>
					<dl>
<dt>2008年6月</dt>
<dd>城南島工場<br>
ハイブリッド・ドライブシステム搭載プレスブレーキHDS8025NT導入</dd>
					</dl>
					<dl>
<dt>2014年2月</dt>
<dd>エコアクション取得</dd>
					</dl>
					<dl>
<dt>2016年5月</dt>
<dd>城南島工場<br>
圧入機ヘガーインサーションマシンHP-618Plus導入</dd>
					</dl>
					<dl>
<dt>2017年5月</dt>
<dd>城南島工場<br>
直流インバータスポット溶接機SLAI45-610導入</dd>
					</dl>
					<dl>
<dt>2018年10月</dt>
<dd>株式会社フクチから豊嶋精密工業株式会社に名称変更</dd>
					</dl>
-->
      </div>
    </section>

    <section class="tagJumpTarget" id="AboutAccess" v-scroll='handleScrollForBackground'>
      <div class="areaH2">
        <h2>アクセス</h2>
      </div>
        <div class="rowView marginBottom0 tagJumpTarget"  id="AboutMap" v-scroll='handleScrollForBackground'>
					<h3><span>周辺地図</span></h3>
					<div class="map">
						<dl>
							<dt>本社工場</dt>
							<dd>〒141-0031 東京都品川区西五反田5-24-8</dd>
						</dl>
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d340.89628372984646!2d139.71225887489345!3d35.623528245943696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ae0b6af6faf%3A0x678a36646a1f2062!2z6LGK5baL57K-5a-G5bel5qWt44ix!5e0!3m2!1sja!2sjp!4v1679803605793!5m2!1sja!2sjp" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
					</div>
					<div class="map">
						<dl>
							<dt>城南島工場</dt>
							<dd>〒143-0002 東京都大田区城南島4-7-2</dd>
						</dl>
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d811.239625305323!2d139.7823504356946!3d35.57941608554357!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601863cd8c659eb3%3A0x786606892f0dc940!2z6LGK5baL57K-5a-G5bel5qWtIOWfjuWNl-WztuW3peWgtA!5e0!3m2!1sja!2sjp!4v1679671652650!5m2!1sja!2sjp" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
				</div>
			</div>

        <div class="rowView tagJumpTarget" id="AboutTrain" v-scroll='handleScrollForBackground'>
					<h3><span>交通</span></h3>
					<dl>
						<dt>本社工場</dt>
							<dd><a href="https://goo.gl/maps/PEpXunw1d1fQzmUMA" target="_blank">東急目黒線不動前駅改札を出て右側の坂道を南西へ進み、3つ目の丁字路を左折、徒歩約5分。</a>
						</dd>
					</dl>
					<dl>
						<dt>城南島工場</dt>
						<dd><a href="https://goo.gl/maps/1WGiJuYh35MBwv1p6" target="_blank">JR大森駅からバスで城南島4丁目バス停へ、城南島4丁目バス停から徒歩約1分。</a>
						</dd>
					</dl>
      </div>
    </section>

    <section class="tagJumpTarget areaAboutRegulations" id="AboutRegulations" v-scroll='handleScrollForBackground'>
      <div class="areaH2">
        <h2>社内規定</h2>
      </div>
      <div class="rowView">
				<dl>
					<dt>化学物質管理規定</dt>
					<dd><router-link :to="{path:'/about/official?list=1', hash:'o-0003'}" class="pageLink">第2版 制定（2026/1/5）</router-link></dd>
				</dl>
			</div>
    </section>

    <section class="tagJumpTarget areaAboutISO" id="AboutISO" v-scroll='handleScrollForBackground'>
      <div class="areaH2">
        <h2>品質マネージメントシステム</h2>
      </div>
      <div class="rowView">
				<p>
国際標準化機構：ISOの認証内容は以下の通りです。
				</p>
				<dl><dt>認証規格</dt><dd>ISO9001:2015 品質マネージメントシステム</dd></dl>
				<dl><dt>認証番号</dt><dd>GIJP-1456-QC</dd></dl>
				<dl><dt>認証取得日</dt><dd>2024年11月18日</dd></dl>
				<dl><dt>認証範囲</dt><dd>東京都品川区西五反田5-24-8<br>
城南島工場:東京都大田区城南島4-7-2</dd></dl>
				<dl><dt>認証内容</dt><dd>精密板金加工、タレパン加工、曲げ加工、スポット溶接加工、溶接加工、組立加工、
板金加工、TIG溶接</dd></dl>
				<dl><dt>審査機関</dt><dd><a href="https://gcerti.jp/" target="_blank"  class="externalLink" rel="nofollow">GCERTI</a></dd></dl>
				<img src="/asset/images/pages/iso/ias.png" alt="IAS ACCREDITED Management Systems Certification Body  G-CERTI ISO9001:2015 ">
				<div class="_block">
					<h3><span>ISO9001:2015認証書</span></h3>
					<p>
<span>有効期間：<span class="brSp"></span>2024年11月18日 〜 2027年11月17日</span>
<img-plus img-src="documents/gcertiCertificae.pdf" img-thumb="" img-alt="ISO9001:2015 品質マネージメントシステム G-CERTI 認証証" :full-screen="true" at-place="single" get-outside="" />
					</p>
				</div>
			</div>
    </section>


	</div><!--container-->
</div>

    <router-view></router-view>
  </main>
</template>

<script>
import imgPlus from '@/components/ImgPlus.vue'

export default {
  name: 'about',
  components:{
    imgPlus,
  },
  data() {
    return {
			pageTitle:"会社情報",
			description:"会社概要、沿革、MAP、電車利用情報を紹介します",
			keywords:"会社情報",
			ogType:"article",
      originListProfile:[],
      originListHistory:[],
		}
	},
  beforeMount:function() {this._log("beforeMount "+this.$options.name)
		this.setProfile()
		this.setHistory()
	},
  mounted: function() {this._log("mounted "+this.$options.name)

/*子が呼び出されているときは、以下をセットしない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', 'aboutCompanyBack')
	/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			this.$store.commit('updateLinkCanonical', '')
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
	
			this.changePageScrollAnchor()
		}
  },
  updated: function() {
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', 'aboutCompanyBack')

	/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			this.$store.commit('updateLinkCanonical', '')
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())

			this.changePageScrollAnchor()
		}
  },
  methods: {
    handleScrollForBackground:function (evt, el) {
//チェック用のエリア設定
      let aViewRect = this.makeViewRect()
      let aViewCenter = parseInt(aViewRect.height/2)
//      let adjustment = window.innerHeight
//対象オブジェクトの情報設定
      const rect = el.getBoundingClientRect()
      const styles = window.getComputedStyle(el)
//対象オブジェクトの実際のサイズ設定
      let rectTopPlusMargin = rect.top - parseInt(styles.marginTop)
      let rectBottomPlusMargin = rect.bottom - parseInt(styles.marginBottom) 
//表示状態保持チェック
      if(this.$_refChangedBuffer() != "") {
        if(this.$_refChangedBuffer() == el.id && (rectBottomPlusMargin < aViewCenter || rectTopPlusMargin > aViewCenter)) {
           this.$_setChangedBuffer("")
        }
        return false
//表示変更チェック
      } else if((aViewRect.top < rectBottomPlusMargin && rectTopPlusMargin < aViewCenter) || (aViewCenter < rect.top && rectTopPlusMargin < aViewCenter)){
        switch(el.id) {
          case 'AboutOverview':
            this.$store.commit('updatePageBackgroundStyle', 'aboutCompanyBack')
            this.$_setChangedBuffer(el.id)
            break;
          case 'AboutHistory':
            this.$store.commit('updatePageBackgroundStyle', 'aboutHistoryBack')
            this.$_setChangedBuffer(el.id)
            break;
          case 'AboutMap':
            this.$store.commit('updatePageBackgroundStyle', 'aboutMapBack')
            this.$_setChangedBuffer(el.id)
            break;
          case 'AboutTrain':
            this.$store.commit('updatePageBackgroundStyle', 'aboutTrainBack')
            this.$_setChangedBuffer(el.id)
            break;
          case 'AboutRegulations':
            this.$store.commit('updatePageBackgroundStyle', 'aboutRegulationBack')
            this.$_setChangedBuffer(el.id)
            break;
          default:
        }
      }
    },
    makeViewRect() {
//背景切り替え用の場所の定義を行う
      const maxHeight = 480 //高さの制限
      let aX = 0
      let aY = 0
      let aWidth = window.innerWidth
      let aHeight = (window.innerHeight/2 > maxHeight)? maxHeight:window.innerHeight/2
      return new DOMRectReadOnly(aX,aY,aWidth,aHeight)
    },

    setProfile() {
			if(this.$store.getters.originListProfile .length == 0 ) {
				/*データがない場合は、storeの状態を監視して、読み込み終了とともにセットする*/
				this.detailName = decodeURI(this.$route.path.match(/([^\/.]+)/g).pop())
				this.$store.watch(
					(state, getters) => getters.originListProfile,
					(newValue, oldValue) => {
						this.originListProfile = this.$store.getters.originListProfile
					}
				)
			} else {
				this.originListProfile = this.$store.getters.originListProfile
			}
    },
    setHistory() {
			if(this.$store.getters.originListHistory .length == 0 ) {
				/*データがない場合は、storeの状態を監視して、読み込み終了とともにセットする*/
				this.detailName = decodeURI(this.$route.path.match(/([^\/.]+)/g).pop())
				this.$store.watch(
					(state, getters) => getters.originListHistory,
					(newValue, oldValue) => {
						this.originListHistory = this.$store.getters.originListHistory
					}
				)
			} else {
				this.originListHistory = this.$store.getters.originListHistory
			}
    },
		dateData(aStr) {
			let aChecked = ""
			let aDate = new Date(aStr)
//データ内容が日付（iso日付）の場合、通常の日付文字列に修正する
			if(this.isInvalidDate(aDate)) {
//ISOデータを含む文字列
				aChecked = this.isoDateToDisplayDate(aDate)
			} else {
//ISOデータを含まない文字列
				aChecked = aStr
			}
			return aChecked
		},
  },
  beforeDestroy:function() {this._log("beforeDestroy "+this.$options.name)
    this.$_setChangedBuffer("")
  },
/*
  destroy:function() {this._log("destroy "+this.$options.name)},
  activated:function() {this._log("activated "+this.$options.name)},
  deactivated:function() {this._log("deactivated "+this.$options.name)},
  beforeUnmount:function() {this._log("beforeUnmount "+this.$options.name)},
  unmounted:function() {this._log("unmounted "+this.$options.name)},
*/
}
</script>

<style>
</style>
